@if (title) {
  <sd-title customClass="brand-h6" [titleLevel]="titleLevel">
    {{title}}
  </sd-title>
}
<ul class="is-check-mark c__content">
  @for (item of items; track item) {
    <li>{{item}}</li>
  }
</ul>
